export default __webpack_public_path__ + "static/media/warning.9358c8c5.svg";